/**
 * **Die Auslastung in Prozent — eine Formel für Startseite und Planung**
 * (N9-02, 05.10.2026). Vergeben durch vorhanden, gerundet; abgeleitet und
 * nicht geliefert (Leitsatz 4). Die beiden Zahlen darin kommen an beiden
 * Stellen aus derselben API-Rechnung (`apps/api/src/dienste/tageszahlen.ts`).
 */
export function auslastungProzent(belegt: number, maschinen: number): number {
  return maschinen ? Math.round((belegt / maschinen) * 100) : 0;
}
